import { getData, postData, putData } from "../../../services/api"

export const getStock = async (l, sum, b, c, page, rowsPerPage) => {
    let _params = `&${b ? b !== 'all' ? 'branchNo=' + b + '&' : '' : ''}${c ? 'name=' + c + '&' : ''}${l ? l !== 'all' ? 'lot=' + l + '&' : '' : ''}${sum ? 'sumLots=' + sum : ''}`

    const res = await getData(`raw-seed/stock?page=${page}&limit=${rowsPerPage}${_params}`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getBranchList = async () => {
    const res = await getData('dbms/branchs')
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getZones = async (BranchNo) => {
    const res = await getData(`dbms/branchs/${BranchNo}/zones`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getCatalogs = async () => {
    const res = await getData(`dbms/itemcatalogs`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getMaterialsList = async () => {
    const res = await getData('dbms/materials')
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getMaterialsRawList = async () => {
    const res = await getData('dbms/materials?forSeedOnly=1')
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const getItemMasterList = async (ItemNo) => {
    let _params = '?limit=0';
    if (ItemNo) {
        _params = '?name=' + ItemNo + '&limit=0'

    }
    const res = await getData('dbms/items' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}
export const getRawItemMasterList = async (ItemNo) => {
    let _params = '?limit=0';
    if (ItemNo) {
        _params = '?name=' + ItemNo + '&limit=0'

    }
    const res = await getData('dbms/raw-items' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}
export const getRawImprovedItemMasterList = async (ItemNo) => {
    let _params = '?limit=0';
    if (ItemNo) {
        _params = '?name=' + ItemNo + '&limit=0'

    }
    const res = await getData('dbms/raw-improved-items' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}
export const getItemDiscardBalanceList = async (branchNo) => {
    let _params = `${branchNo ? '?branchNo=' + branchNo : ''}`

    const res = await getData('discard-seed/balance' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}
export const getItemRawBalanceList = async (branchNo, seedType) => {
    let _params = `?${branchNo ? 'branchNo=' + branchNo + '&' : ''}${'seedCategory=' + seedType}`

    const res = await getData('raw-seed/balance' + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }

}

export const getRawSeedMovementsList = async (l, sum, b, c, page, rowsPerPage, type, category) => {
    let _params = `&${b ? b !== 'all' ? 'branchNo=' + b + '&' : '' : ''}${c ? 'name=' + c + '&' : ''}${l ? l !== 'all' ? 'lot=' + l + '&' : '' : ''}${sum ? 'sumLots=' + sum : ''}`
    const res = await getData(`raw-seed/movements?documentType=${type}&seedCategory=${category}&page=${page}&limit=${rowsPerPage}` + _params)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}

export const addRawSeed = async (body) => {
    const res = await postData(`raw-seed/movements`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const updateRawSeed = async (body) => {
    const res = await putData(`raw-seed/movements/${body?.DocumentNo}`, body)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
export const detailRawSeed = async (documentNo) => {
    const res = await getData(`raw-seed/movements/${documentNo}`)
    if (res.status === true) {
        return res.result
    } else {
        return null
    }
}
